import { render, staticRenderFns } from "./OtherMatterPreview.vue?vue&type=template&id=53b62fc8&scoped=true"
import script from "./OtherMatterPreview.vue?vue&type=script&lang=js"
export * from "./OtherMatterPreview.vue?vue&type=script&lang=js"
import style0 from "./OtherMatterPreview.vue?vue&type=style&index=0&id=53b62fc8&prod&lang=scss&scoped=true"
import style1 from "./OtherMatterPreview.vue?vue&type=style&index=1&id=53b62fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b62fc8",
  null
  
)

export default component.exports